export default "__VITE_ASSET__Zf539nFF__"